import { api } from '../configs/apiConfig';

const BASE_URL = '/LeaveRequest';

const formatDateToUTC = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
};

// Function to check if a string contains time information (has 'T' separator)
const hasTimeComponent = (dateString) => {
    return dateString && dateString.includes('T');
};

const leaveRequestService = {
    getAll: async () => {
        try {
            const response = await api.get(BASE_URL);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getUserRequests: async (userId) => {
        try {
            const response = await api.get(`${BASE_URL}/user/${userId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`${BASE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    create: async (userId, formData) => {
        try {
            if (!window.confirm('Are you sure you want to submit this leave request? This action cannot be undone.')) {
                return null;
            }
            
            const response = await api.post(`${BASE_URL}/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    delete: async (id) => {
        try {
            if (!window.confirm('Are you sure you want to delete this leave request?')) {
                return false;
            }
            await api.delete(`${BASE_URL}/${id}`);
            return true;
        } catch (error) {
            throw error;
        }
    },

    process: async (id, action, comments = '') => {
        try {
            if (!window.confirm(`Are you sure you want to ${action.toLowerCase()} this leave request?`)) {
                return null;
            }
            const response = await api.post(`${BASE_URL}/${id}/process`, {
                action,
                comments
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getRemainingLeaveDays: async (userId) => {
        try {
            const response = await api.get(`${BASE_URL}/remaining-days/${userId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default leaveRequestService;